import _defineProperty from "@babel/runtime/helpers/defineProperty";
class AbortSignalFacade {
  constructor() {
    _defineProperty(this, "aborted", false);
    _defineProperty(this, "reason", '');
    _defineProperty(this, "onabort", () => {});
    _defineProperty(this, "throwIfAborted", () => {});
    _defineProperty(this, "addEventListener", () => {});
    _defineProperty(this, "removeEventListener", () => {});
    _defineProperty(this, "dispatchEvent", () => false);
  }
}
export class AbortControllerFacade {
  abort() {}
  constructor() {
    _defineProperty(this, "signal", new AbortSignalFacade());
    if (typeof window === 'object' && window.AbortController) {
      const controller = new AbortController();
      this.abort = controller.abort.bind(controller);
      this.signal = controller.signal;
    }
  }
}